<template>
  <section v-if="product.type === 'HtmlGame'" class="mt-5" itemscope itemtype="http://schema.org/MobileApplication">
    <h4>{{ $t('product.browserSupport.title', {product: this.globalResources.productTranslation.Single}) }}</h4>
    <b-badge variant="light" class="mx-1" itemprop="browserRequirements">
      {{ $t('product.browserSupport.Chrome') }}
    </b-badge>
    <b-badge variant="light" class="mx-1" itemprop="browserRequirements">
      {{ $t('product.browserSupport.Firefox') }}
    </b-badge>
    <b-badge variant="light" class="mx-1" itemprop="browserRequirements">
      {{ $t('product.browserSupport.Edge') }}
    </b-badge>
    <b-badge variant="light" class="mx-1" itemprop="browserRequirements">
      {{ $t('product.browserSupport.Opera') }}
    </b-badge>
    <b-badge variant="light" class="mx-1" itemprop="browserRequirements">
      {{ $t('product.browserSupport.OperaMini') }}
    </b-badge>
    <b-badge variant="light" class="mx-1" itemprop="browserRequirements">
      {{ $t('product.browserSupport.Safari') }}
    </b-badge>
  </section>
</template>

<script>
export default {
  name: 'ProductBrowserSupport',
  props: {
    product: {
      type: Object,
      default: () => {}
    }
  }
}
</script>
